<template>
  <Nav />
  <div class="container">
    <div class="user-container">
      <div class="user-header d-flex justify-content-between align-items-center">
        <h1>Solicitações de Acesso</h1>
      </div>

      <div class="user-filters d-flex gap-2 mb-3 flex-nowrap align-items-center">
        <select v-model="filterStatus" class="form-select user-filter-select" @change="onFilterChange">
          <option value="">Todos os status</option>
          <option value="pendente">Pendente</option>
          <option value="aprovado">Aprovado</option>
          <option value="rejeitado">Rejeitado</option>
        </select>
        <button class="btn btn-outline-secondary" @click="clearFilters">Limpar Filtros</button>
      </div>

      <div class="user-body">
        <div class="table-responsive">
          <table class="table solicitacoes-table">
            <thead>
              <tr>
                <th scope="col" class="col-nome">Nome</th>
                <th scope="col" class="col-email">Email</th>
                <th scope="col" class="col-municipio">Município</th>
                <th scope="col" class="col-uf">UF</th>
                <th scope="col" class="col-status">Status</th>
                <th scope="col" class="col-acoes">Ações</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="s in solicitacoes" :key="s.id">
                <td class="col-nome">{{ s.nome }}</td>
                <td class="col-email">{{ s.email }}</td>
                <td class="col-municipio">{{ s.municipio_nome }}</td>
                <td class="col-uf">{{ s.uf }}</td>
                <td class="col-status">
                  <span class="badge" :class="badgeClass(s.status)">
                    {{ s.status }}
                  </span>
                </td>
                <td class="col-acoes">
                  <div class="d-flex align-items-center justify-content-end" v-if="s.status === 'pendente'">
                    <button class="btn-icon me-2" @click="confirmarAcao(s, 'aprovar')" title="Aprovar">
                      <i class="bi bi-check-circle text-success"></i>
                    </button>
                    <button class="btn-icon" @click="confirmarAcao(s, 'rejeitar')" title="Rejeitar">
                      <i class="bi bi-x-circle text-danger"></i>
                    </button>
                  </div>
                  <div v-else class="text-muted small text-end">
                    {{ s.aprovado_por || '—' }}
                  </div>
                </td>
              </tr>
              <tr v-if="solicitacoes.length === 0">
                <td colspan="6" class="text-center text-muted py-3">Nenhuma solicitação encontrada.</td>
              </tr>
            </tbody>
          </table>
        </div>

        <div class="fila-pagination d-flex justify-content-between align-items-center mt-3" v-if="total > 0">
          <span class="text-muted small">
            Exibindo {{ solicitacoes.length }} de {{ total }} registros
          </span>
          <div class="d-flex gap-2">
            <button
              class="btn btn-outline-secondary btn-sm"
              :disabled="page === 1"
              @click="goToPage(page - 1)"
            >Anterior</button>
            <span class="btn btn-sm disabled">{{ page }}</span>
            <button
              class="btn btn-outline-secondary btn-sm"
              :disabled="page * 20 >= total"
              @click="goToPage(page + 1)"
            >Próxima</button>
          </div>
        </div>
      </div>
    </div>
  </div>

  <!-- Modal de confirmação -->
  <div class="modal fade" id="confirmacaoModal" tabindex="-1" ref="confirmacaoModal">
    <div class="modal-dialog">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">
            {{ acaoPendente === 'aprovar' ? 'Confirmar Aprovação' : acaoPendente === 'rejeitar' ? 'Confirmar Rejeição' : '' }}
          </h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal"></button>
        </div>
        <div class="modal-body" v-if="solicitacaoSelecionada">
          <p>
            Deseja {{ acaoPendente === 'aprovar' ? 'aprovar' : 'rejeitar' }} a solicitação de
            <strong>{{ solicitacaoSelecionada.nome }}</strong> para o município
            <strong>{{ solicitacaoSelecionada.municipio_nome }}/{{ solicitacaoSelecionada.uf }}</strong>?
          </p>
          <p v-if="acaoPendente === 'aprovar'" class="text-muted small">
            Um usuário será criado e as credenciais de acesso serão informadas ao solicitante.
          </p>
          <p v-if="acaoPendente === 'rejeitar'" class="text-danger small">
            Esta ação não pode ser desfeita.
          </p>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary" data-bs-dismiss="modal">Cancelar</button>
          <button
            type="button"
            :class="acaoPendente === 'aprovar' ? 'btn btn-success' : acaoPendente === 'rejeitar' ? 'btn btn-danger' : 'btn btn-secondary'"
            @click="executarAcao"
            :disabled="loadingAcao || !acaoPendente"
          >
            {{ loadingAcao ? 'Processando...' : (acaoPendente === 'aprovar' ? 'Aprovar' : acaoPendente === 'rejeitar' ? 'Rejeitar' : '') }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axiosApi from "@/axios";
import Nav from "@/components/Nav.vue";
import { mapState, mapActions } from "vuex";

export default {
  name: "Solicitacoes",
  components: { Nav },
  data() {
    return {
      solicitacoes: [],
      filterStatus: "",
      page: 1,
      total: 0,
      totalPages: 0,
      loading: false,
      solicitacaoSelecionada: null,
      acaoPendente: null,
      loadingAcao: false,
    };
  },
  computed: {
    ...mapState(["user", "isAuthLoading"]),
  },
  async created() {
    try {
      await this.validateToken();

      if (this.isAuthLoading) {
        const checkAuth = () => {
          if (!this.isAuthLoading) {
            if (!this.user || this.user.role !== "admin") {
              this.$router.push("/");
            } else {
              this.getSolicitacoes();
            }
          } else {
            setTimeout(checkAuth, 100);
          }
        };
        checkAuth();
      } else {
        if (!this.user || this.user.role !== "admin") {
          this.$router.push("/");
        } else {
          this.getSolicitacoes();
        }
      }
    } catch {
      this.$router.push("/login");
    }
  },
  methods: {
    ...mapActions(["validateToken", "showToast"]),
    async getSolicitacoes() {
      this.loading = true;
      try {
        const params = new URLSearchParams({ page: this.page });
        if (this.filterStatus) params.append("status", this.filterStatus);

        const response = await axiosApi.get(`/api/solicitacoes?${params}`);
        this.solicitacoes = response.data.data;
        this.total = response.data.pagination.total;
        this.totalPages = response.data.pagination.totalPages;
        this.page = response.data.pagination.page;
      } catch {
        this.showToast({
          title: "Erro",
          message: "Não foi possível carregar as solicitações.",
          type: "toast-danger",
          headerClass: "toast-header-danger",
        });
      } finally {
        this.loading = false;
      }
    },
    goToPage(p) {
      if (p < 1 || p > this.totalPages || p === this.page) return;
      this.page = p;
      this.getSolicitacoes();
    },
    onFilterChange() {
      this.page = 1;
      this.getSolicitacoes();
    },
    clearFilters() {
      this.filterStatus = "";
      this.page = 1;
      this.getSolicitacoes();
    },
    badgeClass(status) {
      return {
        pendente: "bg-warning text-dark",
        aprovado: "bg-success",
        rejeitado: "bg-danger",
      }[status] || "bg-secondary";
    },
    confirmarAcao(solicitacao, acao) {
      this.solicitacaoSelecionada = solicitacao;
      this.acaoPendente = acao;
      const modal = new window.bootstrap.Modal(
        document.getElementById("confirmacaoModal")
      );
      modal.show();
    },
    async executarAcao() {
      if (!this.solicitacaoSelecionada || !this.acaoPendente) return;

      this.loadingAcao = true;
      const { id } = this.solicitacaoSelecionada;
      const endpoint = `/api/solicitacoes/${id}/${this.acaoPendente}`;

      try {
        await axiosApi.post(endpoint);

        const mensagem =
          this.acaoPendente === "aprovar"
            ? "Solicitação aprovada. Usuário criado com sucesso."
            : "Solicitação rejeitada.";

        this.showToast({
          title: "Sucesso",
          message: mensagem,
          type: "toast-success",
          headerClass: "toast-header-success",
        });

        this.getSolicitacoes();
      } catch (err) {
        this.showToast({
          title: "Erro",
          message: err.response?.data?.message || "Não foi possível processar a solicitação.",
          type: "toast-danger",
          headerClass: "toast-header-danger",
        });
      } finally {
        const modal = window.bootstrap.Modal.getInstance(
          document.getElementById("confirmacaoModal")
        );
        if (modal) modal.hide();
        this.loadingAcao = false;
        this.solicitacaoSelecionada = null;
        this.acaoPendente = null;
      }
    },
  },
};
</script>

<style scoped>
.user-container {
  max-width: 1200px;
  margin: 0 auto;
  padding: 20px 0;
}

.user-header {
  margin-bottom: 20px;
}

.user-filter-select {
  max-width: 200px;
  min-width: 160px;
}

.solicitacoes-table {
  width: 100%;
  table-layout: fixed;
}

.solicitacoes-table .col-nome  { width: 18%; }
.solicitacoes-table .col-email { width: 25%; }
.solicitacoes-table .col-municipio { width: 25%; }
.solicitacoes-table .col-uf     { width: 7%; }
.solicitacoes-table .col-status { width: 10%; }
.solicitacoes-table .col-acoes  { width: 15%; }

.solicitacoes-table td {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
</style>
